import { render, staticRenderFns } from "./commonFooter.vue?vue&type=template&id=f68ededa&scoped=true&"
import script from "./commonFooter.vue?vue&type=script&lang=js&"
export * from "./commonFooter.vue?vue&type=script&lang=js&"
import style0 from "./commonFooter.vue?vue&type=style&index=0&id=f68ededa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f68ededa",
  null
  
)

export default component.exports